var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hicon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33301 5.8335L9.80215 7.28959C10.9738 8.45079 11.5596 9.03139 11.6498 9.73905C11.6719 9.91244 11.6719 10.0879 11.6498 10.2613C11.5596 10.9689 10.9738 11.5495 9.80215 12.7107L8.33301 14.1668",
    stroke: "#1877F2",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlue);
export default __webpack_public_path__ + "static/media/arrow-right-blue.a53d3f4be2d0c0b4d58523e5c29b0097.svg";
export { ForwardRef as ReactComponent };